
<template>
  <div>
    <div style="height: 500px"></div>
    <div style="overflow: hidden" :style="{ width: width }">
      <div
        style="
          width: 150vw;
          display: flex;
          justify-content: center;
          margin-left: -25vw;
        "
      >
        <swiper class="swiper" :options="swiperOption" v-if="showresearch">
          <swiper-slide v-for="(item, index) in bannerlist" :key="index">
            <img :src="$url + item.picture" alt="" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "swiper-example-grab-cursor",
  title: "Grab cursor",
  components: {
    Swiper,
    SwiperSlide,
  },
  mounted() {
    this.width = document.body.clientWidth + "px";
    // this.$http
    //   .post("/index/news/list", {
    //     type: "research_direction",
    //   })
    //   .then((res) => {
    //     this.research = res.data.data;
    //     this.$nextTick(() => {
    //       this.showresearch = true;
    //     });
    //   });
    this.$http
      .post("/index/banner/list", {
        type: "index",
      })
      .then((res) => {
        this.bannerlist = res.data.data;
        this.ifshowbannner = true;
      });
    window.onresize = () => {
      this.width = document.body.clientWidth + "px";
    };
  },
  data() {
    return {
      bannerlist:[],
      showresearch: false,
      research: "",
      width: "",
      swiperOption: {
        slidesPerView: 2,
        centeredSlides: true,
        spaceBetween: 30,
        grabCursor: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.swiper{
  width: 100%;
  height: 500px;
}
img {
  width: 100%;
  height: 300px;
}
</style>


// WEBPACK FOOTER //
// src/views/test.vue